import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useContext } from 'react';
import { Link } from 'gatsby';
import { FaTimesCircle } from 'react-icons/fa';
import currency from 'currency.js';
import { Button } from '@chakra-ui/react';
import Spacer from '@interness/web-core/src/components/structure/Spacer/Spacer';
import Separator from '@interness/web-core/src/components/structure/Separator/Separator';
import ConditionalWrapper from '@interness/web-core/src/components/structure/ConditionalWrapper/ConditionalWrapper';
import { StoreContext } from '../../context/Store';
import CountSelector from '../CountSelector/CountSelector';
import * as S from './styles';
import { endpoints } from '../../config';
import PriceTag from '../PriceTag';
import { CheckoutContext } from '../../context/Checkout';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Cart = _ref => {
  let {
    checkoutMode,
    orderCart,
    orderConfirmationMode,
    orderShippingCost
  } = _ref;
  if (orderConfirmationMode) {
    checkoutMode = true;
  }
  const {
    cart: localCart,
    cartDispatcher,
    storeRootPath,
    settings
  } = useContext(StoreContext);
  const {
    shippingCost: checkoutShippingCost
  } = useContext(CheckoutContext);
  let cart;
  const shippingCost = orderShippingCost ? orderShippingCost : checkoutShippingCost;
  if (orderCart) {
    cart = _objectSpread(_objectSpread({}, orderCart), {}, {
      products: orderCart.products.map(p => {
        const struc = _objectSpread(_objectSpread({}, p), {}, {
          product: p.product_id
        });
        delete struc.product_id;
        return struc;
      })
    });
  } else {
    cart = localCart;
  }
  const totalWithShipping = currency(cart.totalPriceBrutto).add(shippingCost).value;

  // const features = [''];

  const onRemoveProduct = id => {
    try {
      cartDispatcher({
        type: 'remove',
        payload: {
          id
        }
      });
    } catch (e) {
      console.log(e);
    }
  };
  const onChangeCount = (newCount, cartItemId) => {
    cartDispatcher({
      type: 'changeCount',
      payload: {
        cartId: cartItemId,
        newCount: parseInt(newCount)
      }
    });
  };
  return ___EmotionJSX(React.Fragment, null, cart.totalCount === 0 && ___EmotionJSX(React.Fragment, null, ___EmotionJSX("p", null, "Der Warenkorb ist leer."), ___EmotionJSX(Link, {
    to: storeRootPath
  }, "Jetzt Produkte entdecken."), ___EmotionJSX("br", null), ___EmotionJSX(Spacer, null)), cart.totalCount > 0 && ___EmotionJSX(S.List, null, cart.products.map(cartItem => {
    const {
      product
    } = cartItem;
    const stock = cartItem.variant ? cartItem.variant.stock : product.stock;
    return ___EmotionJSX(S.Row, {
      key: cartItem.cartId || cartItem.product.id
    }, checkoutMode && ___EmotionJSX("div", null, cartItem.count, "x"), ___EmotionJSX("div", null, ___EmotionJSX(ConditionalWrapper, {
      wrapper: children => ___EmotionJSX(Link, {
        to: cartItem.path
      }, children),
      condition: cartItem.path
    }, ___EmotionJSX("div", null, !checkoutMode && ___EmotionJSX(React.Fragment, null, product.images.length === 0 ? ___EmotionJSX("img", {
      src: "https://placehold.jp/333/ffffff/100x100.png?text=Kein%20Bild",
      alt: "Kein Bild"
    }) : ___EmotionJSX("img", {
      src: `${endpoints.thumbnails}/${product.images.filter(image => !!image.file_id)[0].file_id.private_hash}?key=e-detail-thumbnail`,
      alt: product.display_name
    })), ___EmotionJSX("span", null, product.display_name))), cartItem.personalization && ___EmotionJSX("p", null, "Personalisiert"), cartItem.variant && ___EmotionJSX(React.Fragment, null, ___EmotionJSX("b", null, "Variante:"), ___EmotionJSX("span", {
      style: {
        marginLeft: '5px'
      }
    }, cartItem.variant.display_name))), !checkoutMode && ___EmotionJSX("div", null, ___EmotionJSX("p", null, "Einzelpreis"), ___EmotionJSX(PriceTag, {
      price: cartItem.priceBrutto
    })), !checkoutMode && ___EmotionJSX("div", null, ___EmotionJSX("p", null, "Zwischensumme"), ___EmotionJSX(PriceTag, {
      price: currency(cartItem.priceBrutto).multiply(cartItem.count)
    })), !checkoutMode && ___EmotionJSX("div", {
      style: {
        display: 'flex'
      }
    }, ___EmotionJSX(CountSelector, {
      cartMode: true,
      isInCart: cartItem,
      countInCart: cartItem.count,
      currentCount: cartItem.count,
      productStock: stock,
      onChangeCount: onChangeCount
    }), ___EmotionJSX(S.RemoveButton, {
      "aria-label": "Aus Warenkorb entfernen",
      onClick: () => onRemoveProduct(cartItem.cartId)
    }, ___EmotionJSX(FaTimesCircle, null))));
  })), ___EmotionJSX(Separator, null), cart.totalCount > 0 && ___EmotionJSX("div", {
    style: {
      textAlign: 'right'
    }
  }, ___EmotionJSX(React.Fragment, null, ___EmotionJSX("p", {
    style: {
      fontSize: '0.6rem',
      marginBottom: '0',
      fontWeight: 'bold'
    }
  }, "Zwischensumme (exkl. Versandkosten)"), ___EmotionJSX("b", {
    style: {
      fontSize: '1.4rem'
    }
  }, ___EmotionJSX(PriceTag, {
    showInfo: false,
    price: cart.totalPriceBrutto
  }))), ___EmotionJSX(Spacer, {
    height: 20
  }), ___EmotionJSX(React.Fragment, null, ___EmotionJSX("div", {
    style: {
      fontSize: '0.8rem'
    }
  }, "Versandkosten: ", ___EmotionJSX(PriceTag, {
    replaceZero: false,
    price: shippingCost
  })), ___EmotionJSX(Spacer, {
    height: 20
  })), ___EmotionJSX(React.Fragment, null, ___EmotionJSX("p", {
    style: {
      fontSize: '0.6rem',
      marginBottom: '0',
      fontWeight: 'bold'
    }
  }, "Gesamtsumme"), ___EmotionJSX("b", {
    style: {
      fontSize: '1.4rem'
    }
  }, ___EmotionJSX(PriceTag, {
    showInfo: false,
    price: totalWithShipping
  }))), settings && settings.data.default_tax_percent > 0 && ___EmotionJSX("div", {
    style: {
      fontSize: '0.6rem'
    }
  }, "Enthaltene Mehrwertsteuer: ", ___EmotionJSX(PriceTag, {
    showMwst: true,
    replaceZero: false,
    price: totalWithShipping
  })), ___EmotionJSX(Spacer, {
    height: 40
  }), ___EmotionJSX("div", {
    style: {
      textAlign: 'center',
      maxWidth: '640px',
      margin: 'auto'
    }
  }, !checkoutMode && ___EmotionJSX("div", null, ___EmotionJSX("div", null, ___EmotionJSX(Button, {
    width: "100%",
    colorScheme: "brand",
    as: Link,
    to: `${storeRootPath}/kasse`,
    isDisabled: cart.totalCount === 0
  }, "Zur Kasse gehen"), ___EmotionJSX(Spacer, {
    height: 10
  })), cart.totalCount !== 0 && ___EmotionJSX("div", {
    style: {
      marginTop: '20px'
    }
  }, ___EmotionJSX(Button, {
    width: "100%",
    colorScheme: "brand",
    variant: "outline",
    as: Link,
    to: storeRootPath
  }, "Weiter einkaufen"))))));
};
Cart.defaultProps = {
  shippingCost: 0
};
export default Cart;